import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  TextField,
  Typography,
  CircularProgress,
  Paper,
  Fade
} from '@mui/material';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Property_pincoder_new from "./../../../src/Images/property_pincode_new.png";
import { BASE_URL, RAZORPAY_URL } from '../Api/ApiUrls';

const VerifyEmailPage = () => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { name, email, phone, password, usertype, referred_by } = location.state || {};

 const handleVerifyOtp = async () => {
  console.log("👉 OTP Verification Started");

  setLoading(true);
  setError('');

  try {
    // =========================
    // ✅ VERIFY OTP API
    // =========================
    const otpPayload = { email, otp };

    console.log("📤 Sending OTP Verify Request:");
    console.log(JSON.stringify(otpPayload, null, 2));

    const otpRes = await fetch(`${BASE_URL}/reg-verify-otp/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(otpPayload),
    });

    console.log("📥 OTP Response Status:", otpRes.status);

    const otpData = await otpRes.json();

    console.log("📥 OTP Response Data:");
    console.log(JSON.stringify(otpData, null, 2));

    if (!otpRes.ok) {
      console.error("❌ OTP Verification Failed:", otpData);
      setError(otpData.message || 'Invalid OTP');
      setLoading(false);
      return;
    }

    console.log("✅ OTP Verified Successfully");


    // =========================
    // ✅ RAZORPAY CUSTOMER API
    // =========================
    const razorPayload = {
      name,
      email,
      contact: phone,
    };

    console.log("📤 Creating Razorpay Customer:");
    console.log(JSON.stringify(razorPayload, null, 2));

    const razorRes = await fetch(`${RAZORPAY_URL}/api/razorpay/customer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(razorPayload),
    });

    console.log("📥 Razorpay Response Status:", razorRes.status);

    const razorData = await razorRes.json();

    console.log("📥 Razorpay Response Data:");
    console.log(JSON.stringify(razorData, null, 2));

    if (!razorRes.ok) {
      console.error("❌ Razorpay Customer Creation Failed:", razorData);
      setError('Failed to create Razorpay customer');
      setLoading(false);
      return;
    }

    console.log("✅ Razorpay Customer Created:", razorData?.customer?.id);


    // =========================
    // ✅ CREATE USER API
    // =========================
    const userPayload = {
      username: name,
      first_name: name,
      last_name: name,
      email,
      mobile_no: phone,
      password,
      // role: 1,
      referred_by,
      razor_user_id: razorData.customer.id,
      tersm_and_condition: true,
      user_type: usertype,
    };

    console.log("📤 Creating User:");
    console.log(JSON.stringify(userPayload, null, 2));

    const userRes = await fetch(`${BASE_URL}/users/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userPayload),
    });

    console.log("📥 User API Response Status:", userRes.status);

    const userData = await userRes.json().catch(() => ({}));

    console.log("📥 User API Response Data:");
    console.log(JSON.stringify(userData, null, 2));

    if (!userRes.ok) {
      console.error("❌ User Creation Failed:", userData);
      setError(userData.error || 'User creation failed');
      setLoading(false);
      return;
    }

    console.log("✅ User Created Successfully");


    // =========================
    // ✅ SUCCESS NAVIGATION
    // =========================
    console.log("🚀 Redirecting to Login/Home Page");

    navigate('/');

  } catch (err) {
    console.error("🔥 Exception Occurred:", err);
    setError('Something went wrong');
  }

  console.log("🔄 OTP Flow Completed");
  setLoading(false);
};

  return (
    <Fade in timeout={700}>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #0d0d25, #000)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6,
        }}
      >
        <Container maxWidth="xs">
          <CssBaseline />

          <Paper
            elevation={10}
            sx={{
              p: 4,
              borderRadius: 4,
              background: 'rgba(255, 255, 255, 0.02)',
              border: '1px solid rgba(255, 215, 0, 0.3)',
              backdropFilter: 'blur(10px)',
              textAlign: 'center',
              color: '#fff',
            }}
          >
            {/* Logo */}
            <Box
              component="img"
              src={Property_pincoder_new}
              alt="Logo"
              sx={{
                width: 180,
                height: 120,
                mb: 2,
                mx: 'auto',
                borderRadius: 2,
                boxShadow: '0 0 20px #ffd700',
                display: 'block',
              }}
            />

            {/* Title */}
            <Typography variant="h5" sx={{ color: '#f7e896', fontWeight: 600, mb: 2 }}>
              Verify Email
            </Typography>

            {/* Show Email */}
            <Typography sx={{ fontSize: 14, color: '#ccc', mb: 2 }}>
              OTP sent to <b>{email}</b>
            </Typography>

            {/* Error */}
            {error && (
              <Typography color="error" sx={{ fontSize: 14, mb: 2 }}>
                {error}
              </Typography>
            )}

            {/* OTP Input */}
            <TextField
              margin="normal"
              required
              fullWidth
              label="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              InputProps={{
                sx: {
                  backgroundColor: 'rgba(255,255,255,0.05)',
                  borderRadius: 2,
                  color: 'white',
                },
              }}
              InputLabelProps={{ style: { color: '#ccc' } }}
            />

            {/* Button */}
            <Button
              fullWidth
              variant="contained"
              onClick={handleVerifyOtp}
              disabled={loading}
              sx={{
                mt: 3,
                mb: 2,
                background: 'linear-gradient(135deg, #f1e57c, #e6ce45)',
                color: '#000',
                fontWeight: 'bold',
                '&:hover': {
                  background: 'linear-gradient(135deg, #ffe85c, #f0d53e)',
                },
              }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Verify OTP'}
            </Button>

            {/* Back to login */}
            <Typography
              component={Link}
              to="/register"
              sx={{
                color: 'rgb(250, 225, 85)',
                display: 'block',
                mt: 2,
                textDecoration: 'none',
              }}
            >
              Back to Register
            </Typography>

          </Paper>
        </Container>
      </Box>
    </Fade>
  );
};

export default VerifyEmailPage;